import _get from 'lodash/get';
import { GET_GALLERY_DETAILS_BY_ID_SUCCESS } from '../actionTypes/GalleryActionTypes';

export default function relatedSearch(state = null, action) {
    // NOSONAR
    switch (action.type) {
        case GET_GALLERY_DETAILS_BY_ID_SUCCESS:
            return _get(action.galleryDetails, 'relatedTerms') || [];
        default:
            return state;
    }
}
